var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { components } from 'react-select';
import { SelectBoxControlWrapper, TagBoxControlWrapper, TagsBoxValueContainerWrapper } from '../styles';
import React from 'react';
export var SelectBoxControl = function (props) {
    return (React.createElement(SelectBoxControlWrapper, __assign({ isFocused: props.isFocused }, props.innerProps, props.innerRef), props.children));
    // return <components.Control {...props} />;
};
export var TagBoxControl = function (props) {
    return (React.createElement(TagBoxControlWrapper, __assign({ isFocused: props.isFocused }, props.innerProps, props.innerRef), props.children));
    // return <components.Control {...props} />;
};
export var SelectBoxValueContainer = function (props) {
    return React.createElement(components.ValueContainer, __assign({}, props));
};
export var TagsBoxValueContainer = function (props) {
    return (React.createElement(TagsBoxValueContainerWrapper, null, props.children));
};
//# sourceMappingURL=selectBoxControl.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { components } from 'react-select';
import { SelectBoxControlWrapper, TagBoxControlWrapper, TagsBoxValueContainerWrapper } from '../styles';
import React from 'react';
export var SelectBoxControl = function (props) {
    return (React.createElement(SelectBoxControlWrapper, __assign({ isFocused: props.isFocused }, props.innerProps, props.innerRef), props.children));
    // return <components.Control {...props} />;
};
export var TagBoxControl = function (props) {
    return (React.createElement(TagBoxControlWrapper, __assign({ isFocused: props.isFocused }, props.innerProps, props.innerRef), props.children));
    // return <components.Control {...props} />;
};
export var SelectBoxValueContainer = function (props) {
    return React.createElement(components.ValueContainer, __assign({}, props));
};
export var TagsBoxValueContainer = function (props) {
    return (React.createElement(TagsBoxValueContainerWrapper, null, props.children));
};
//# sourceMappingURL=selectBoxControl.js.map